import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";

// 引入布局和保护组件
import { AppLayout } from "./components/AppLayout";
import { ProtectedRoute } from "./components/ProtectedRoute";

// 引入页面组件
import Welcome from "./pages/Welcome";
import Login from "./pages/AuthPage";
import Main from "./pages/Main";
import MyGems from "./pages/MyGems";
import GemReport from "./pages/GemReport";
import MonthlyGemReport from "./pages/MonthlyGemReport";
import ComingSoon from "./pages/ComingSoon";
import MentorDeepDivePage from "./pages/MentorDeepDive";
import MentorChatPage from "./pages/MentorChatPage";
import Settings from "./pages/Settings";
import NotFound from "./pages/NotFound";
import SharePreviewPage from "./pages/SharePreviewPage";
import ActorsGallery from "./pages/ActorsGallery"; 
import LifeEditorPage from "./pages/LifeEditorPage.tsx";
import LifePlayPage from "./pages/LifePlay";
import MeditationLibrary from "./pages/MeditationLibrary";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />

      <Routes>
        {/* 默认 / 重定向到 /welcome */}
        <Route path="/" element={<Navigate to="/welcome" replace />} />

        {/* 公开页面 */}
        <Route path="/welcome" element={<Welcome />} />
        <Route path="/login" element={<Login />} />

        {/* 受保护页面 (登录后才能访问) - 统一使用 AppLayout */}
        {/* 1. Today's Gem (主页) */}
        <Route
          path="/main"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Main />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        
        {/* 为了兼容旧链接，增加 /today 别名指向 Main */}
        <Route
          path="/today"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Main />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 2. My Gems (日记列表) */}
        <Route
          path="/my-gems"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MyGems />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 2b. Monthly Gem Report */}
        <Route
          path="/my-gems/monthly-report"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MonthlyGemReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 3. 15 Actors Gems (✨ 新增页面 ✨) */}
        <Route
          path="/actors"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ActorsGallery />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 4. Gem Report (日记详情) */}
        <Route
          path="/gem/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <GemReport />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 5. Mentor Deep Dive */}
        <Route
          path="/mentor"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MentorDeepDivePage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Mentor Chat with specific mentor */}
        <Route
          path="/mentor/:mentorId/chat"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MentorChatPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* 6. Coming Soon (旧占位) */}
        <Route
          path="/coming-soon"
          element={
            <ProtectedRoute>
              <AppLayout>
                <ComingSoon />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Meditation Library */}
        <Route
          path="/meditation"
          element={
            <ProtectedRoute>
              <AppLayout>
                <MeditationLibrary />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Life Editor */}
        <Route
          path="/life-editor"
          element={
            <ProtectedRoute>
              <AppLayout>
                <LifeEditorPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />
        {/* Life Editor: Play route */}
        <Route
          path="/life-editor/play/:id"
          element={
            <ProtectedRoute>
              <AppLayout>
                <LifePlayPage />
              </AppLayout>
            </ProtectedRoute>
          }
        />


        {/* 6. Settings (设置) */}
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <AppLayout>
                <Settings />
              </AppLayout>
            </ProtectedRoute>
          }
        />

        {/* Share 预览页：通常不需要侧边栏，独立显示 */}
        <Route
          path="/share-preview"
          element={
            <ProtectedRoute>
              <SharePreviewPage />
            </ProtectedRoute>
          }
        />

        {/* 404 页面 - 即使是404最好也有Layout */}
        <Route
          path="*"
          element={
            <AppLayout>
              <NotFound />
            </AppLayout>
          }
        />
      </Routes>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;